module.exports = __webpack_public_path__ + "img/converter.542f975c.png";